var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:18;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.9,509.4c0.1-217.8,177.4-394.7,395.6-394.6c218,0.1,394.9,177.3,394.7,395.4 C896,728,718.5,904.6,500.2,904.3C282.7,904,105.8,726.8,105.9,509.4z M844,509.6c0-188.6-153.7-342.1-342.7-342.2 c-189-0.1-343,153.4-343.1,341.8c-0.1,188.8,153.9,342.5,343,342.4C690.3,851.5,844,698.1,844,509.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6,706.1c-0.1-5.1,2.8-10,7.2-14.5c35.2-35.3,70.3-70.6,105.4-105.9c24.1-24.2,48.1-48.5,72.3-72.5 c2.9-2.9,3.1-4.3,0.1-7.3c-59.2-59.3-118.2-118.8-177.3-178.2c-4.5-4.6-7.8-9.5-7.6-16.2c0.2-8.1,3.9-14.1,11.1-17.6 c7.4-3.6,14.6-2.5,21,2.7c1.4,1.1,2.7,2.5,4,3.8c68,68.4,135.9,136.8,204,205.2c3.1,3.1,3.1,4.6,0,7.7 c-68.5,68.6-136.8,137.4-205.1,206.2c-5.4,5.5-11.5,8.4-19.2,7C416.3,724.8,409.8,717,409.6,706.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.e3bee9b9c1b7a1bc4d7517bfb7b98b21.svg";
export { ForwardRef as ReactComponent };